module.exports = __webpack_public_path__ + "img/autospin_btn.a55dbaa1.png";